import { createReducer, on } from '@ngrx/store';
import * as LivespaceActions from './livespace.actions';

export interface LivespaceState {
  connected: boolean;
  connecting: boolean;
  connectError: string | null;
  livespace_contact: any;
  livespace_companies: any;
  livespace_processes: any;
  livespace_sources: any;
  livespace_users: any;
  livespace_products: any;
  livespace_current_user: any;
  livespace_deals: any;
  livespace_new_contact: any;
  livespace_new_company: any;
  livespace_new_deal: any;
  loadingLivespace: boolean;
  error: any;
}

const initialState: LivespaceState = {
  connected: false,
  connecting: false,
  connectError: null,
  livespace_contact: null,
  livespace_companies: null,
  livespace_processes: null,
  livespace_sources: null,
  livespace_users: null,
  livespace_products: null,
  livespace_current_user: null,
  livespace_deals: null,
  livespace_new_contact: null,
  livespace_new_company: null,
  livespace_new_deal: null,
  loadingLivespace: false,
  error: null,
};

export const livespaceReducer = createReducer(
  initialState,

  // Connect
  on(LivespaceActions.livespaceConnect, (state) => ({
    ...state,
    connecting: true,
    connectError: null,
  })),
  on(LivespaceActions.livespaceConnectSuccess, (state) => ({
    ...state,
    connected: true,
    connecting: false,
    connectError: null,
  })),
  on(LivespaceActions.livespaceConnectFailure, (state, { error }) => ({
    ...state,
    connecting: false,
    connectError: error,
  })),

  // Disconnect
  on(LivespaceActions.livespaceDisconnect, (state) => ({
    ...state,
    loadingLivespace: true,
  })),
  on(LivespaceActions.livespaceDisconnectSuccess, (state) => ({
    ...state,
    connected: false,
    loadingLivespace: false,
  })),
  on(LivespaceActions.livespaceDisconnectFailure, (state, { error }) => ({
    ...state,
    error,
    loadingLivespace: false,
  })),

  // Get Contact
  on(LivespaceActions.getLivespaceContact, (state) => ({
    ...state,
    loadingLivespace: true,
    error: null,
  })),
  on(
    LivespaceActions.getLivespaceContactSuccess,
    (state, { livespace_contact }) => ({
      ...state,
      livespace_contact,
      loadingLivespace: false,
      error: null,
    }),
  ),
  on(LivespaceActions.getLivespaceContactFailure, (state, { error }) => ({
    ...state,
    error,
    loadingLivespace: false,
    livespace_contact: null,
  })),

  // Get Companies
  on(LivespaceActions.getLivespaceCompanies, (state) => ({
    ...state,
    loadingLivespace: true,
    error: null,
  })),
  on(
    LivespaceActions.getLivespaceCompaniesSuccess,
    (state, { livespace_companies }) => ({
      ...state,
      livespace_companies,
      loadingLivespace: false,
      error: null,
    }),
  ),
  on(LivespaceActions.getLivespaceCompaniesFailure, (state, { error }) => ({
    ...state,
    error,
    loadingLivespace: false,
    livespace_companies: null,
  })),

  // Get Processes
  on(LivespaceActions.getLivespaceProcesses, (state) => ({
    ...state,
    loadingLivespace: true,
    error: null,
  })),
  on(
    LivespaceActions.getLivespaceProcessesSuccess,
    (state, { livespace_processes }) => ({
      ...state,
      livespace_processes,
      loadingLivespace: false,
      error: null,
    }),
  ),
  on(LivespaceActions.getLivespaceProcessesFailure, (state, { error }) => ({
    ...state,
    error,
    loadingLivespace: false,
  })),

  // New Contact
  on(LivespaceActions.livespaceNewContact, (state) => ({
    ...state,
    loadingLivespace: true,
    error: null,
  })),
  on(
    LivespaceActions.livespaceNewContactSuccess,
    (state, { livespace_new_contact }) => ({
      ...state,
      livespace_new_contact,
      livespace_contact: null,
      loadingLivespace: false,
      error: null,
    }),
  ),
  on(LivespaceActions.livespaceNewContactFailure, (state, { error }) => ({
    ...state,
    error,
    loadingLivespace: false,
  })),

  // New Company
  on(LivespaceActions.livespaceNewCompany, (state) => ({
    ...state,
    loadingLivespace: true,
    error: null,
  })),
  on(
    LivespaceActions.livespaceNewCompanySuccess,
    (state, { livespace_new_company }) => ({
      ...state,
      livespace_new_company,
      loadingLivespace: false,
      error: null,
    }),
  ),
  on(LivespaceActions.livespaceNewCompanyFailure, (state, { error }) => ({
    ...state,
    error,
    loadingLivespace: false,
  })),

  // Update Contact
  on(LivespaceActions.livespaceUpdateContact, (state) => ({
    ...state,
    livespace_contact: null,
    loadingLivespace: true,
    error: null,
  })),
  on(
    LivespaceActions.livespaceUpdateContactSuccess,
    (state, { livespace_updated_contact }) => ({
      ...state,
      livespace_contact: livespace_updated_contact,
      loadingLivespace: false,
      error: null,
    }),
  ),
  on(LivespaceActions.livespaceUpdateContactFailure, (state, { error }) => ({
    ...state,
    error,
    loadingLivespace: false,
  })),

  // Update Company
  on(LivespaceActions.livespaceUpdateCompany, (state) => ({
    ...state,
    livespace_new_company: null,
    loadingLivespace: true,
    error: null,
  })),
  on(
    LivespaceActions.livespaceUpdateCompanySuccess,
    (state, { livespace_updated_company }) => ({
      ...state,
      livespace_new_company: livespace_updated_company,
      loadingLivespace: false,
      error: null,
    }),
  ),
  on(LivespaceActions.livespaceUpdateCompanyFailure, (state, { error }) => ({
    ...state,
    error,
    loadingLivespace: false,
  })),

  // Get Deals
  on(LivespaceActions.getLivespaceDeals, (state) => ({
    ...state,
    livespace_deals: null,
    loadingLivespace: true,
    error: null,
  })),
  on(
    LivespaceActions.getLivespaceDealsSuccess,
    (state, { livespace_deals }) => ({
      ...state,
      livespace_deals,
      loadingLivespace: false,
      error: null,
    }),
  ),
  on(LivespaceActions.getLivespaceDealsFailure, (state, { error }) => ({
    ...state,
    error,
    loadingLivespace: false,
    livespace_deals: null,
  })),

  // New Deal
  on(LivespaceActions.livespaceNewDeal, (state) => ({
    ...state,
    loadingLivespace: true,
    error: null,
  })),
  on(
    LivespaceActions.livespaceNewDealSuccess,
    (state, { livespace_new_deal }) => ({
      ...state,
      livespace_new_deal,
      loadingLivespace: false,
      error: null,
    }),
  ),
  on(LivespaceActions.livespaceNewDealFailure, (state, { error }) => ({
    ...state,
    error,
    loadingLivespace: false,
  })),

  // Get Sources
  on(LivespaceActions.getLivespaceSources, (state) => ({
    ...state,
    loadingLivespace: true,
    error: null,
  })),
  on(
    LivespaceActions.getLivespaceSourcesSuccess,
    (state, { livespace_sources }) => ({
      ...state,
      livespace_sources,
      loadingLivespace: false,
      error: null,
    }),
  ),
  on(LivespaceActions.getLivespaceSourcesFailure, (state, { error }) => ({
    ...state,
    error,
    loadingLivespace: false,
  })),

  // Get Users
  on(LivespaceActions.getLivespaceUsers, (state) => ({
    ...state,
    loadingLivespace: true,
    error: null,
  })),
  on(
    LivespaceActions.getLivespaceUsersSuccess,
    (state, { livespace_users }) => ({
      ...state,
      livespace_users,
      loadingLivespace: false,
      error: null,
    }),
  ),
  on(LivespaceActions.getLivespaceUsersFailure, (state, { error }) => ({
    ...state,
    error,
    loadingLivespace: false,
  })),

  // Get Products
  on(LivespaceActions.getLivespaceProducts, (state) => ({
    ...state,
    loadingLivespace: true,
    error: null,
  })),
  on(
    LivespaceActions.getLivespaceProductsSuccess,
    (state, { livespace_products }) => ({
      ...state,
      livespace_products,
      loadingLivespace: false,
      error: null,
    }),
  ),
  on(LivespaceActions.getLivespaceProductsFailure, (state, { error }) => ({
    ...state,
    error,
    loadingLivespace: false,
  })),

  // Get Current User
  on(LivespaceActions.getLivespaceCurrentUser, (state) => ({
    ...state,
    loadingLivespace: true,
    error: null,
  })),
  on(
    LivespaceActions.getLivespaceCurrentUserSuccess,
    (state, { livespace_current_user }) => ({
      ...state,
      livespace_current_user,
      loadingLivespace: false,
      error: null,
    }),
  ),
  on(LivespaceActions.getLivespaceCurrentUserFailure, (state, { error }) => ({
    ...state,
    error,
    loadingLivespace: false,
  })),

  // Clear
  on(LivespaceActions.clearLivespace, () => initialState),
);
